export const scoreOverviewParser = data => {
  const scoreOverviewData = data.map(item => ({
    title: item.variable,
    score: item.value ?? 0,
    companyImpact: item.companyImpact * 100,
    extCostsToRevenue: item.extCostsToRevenue,
    supplyChain: 100 - item.companyImpact * 100 - (item.downstreamImpact ? item.downstreamImpact * 100 : 0),
    downstreamImpact: item.downstreamImpact ? item.downstreamImpact * 100 : 0,
    valueWithoutDownstream: item.valueWithoutDownstream ?? 0,
  }));

  const getDataByName = name => scoreOverviewData.find(({ title }) => title === name);

  return [
    getDataByName('Environment'),
    getDataByName('Social'),
    getDataByName('Governance'),
    getDataByName('Total'),
  ];
};
